import { AdminSettingsLayout } from "metabase/admin/components/AdminLayout/AdminSettingsLayout";
import { shouldShowTenantsUpsell } from "metabase/admin/people/selectors";
import { useSelector } from "metabase/redux";
import { getLocation } from "metabase/selectors/routing";

import { PeopleNav } from "../../components/PeopleNav";

export const AdminPeopleApp = ({ children }: { children: React.ReactNode }) => {
  // No title here: every route this wraps (PeopleListingApp, GroupsListingApp,
  // GroupDetailApp) already sets its own descriptive titleIndex:1 title, and
  // this wrapper's own text would either duplicate "People" or, worse, tie
  // with a child's title and land on the wrong side depending on mount order.
  const location = useSelector(getLocation);
  const showTenantsUpsell = useSelector(shouldShowTenantsUpsell);
  const isTenantsRoute = location?.pathname.startsWith("/admin/people/tenants");
  const isFullWidth = showTenantsUpsell && isTenantsRoute;

  return (
    <AdminSettingsLayout
      sidebar={<PeopleNav />}
      maw="80rem"
      fullWidth={isFullWidth}
    >
      {children}
    </AdminSettingsLayout>
  );
};
